// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { initializeStores } from './store'
import { resetPlugin, persistStatePlugin } from './store/plugins'
import ApiService from './services/apiService'
import { permissionDirective } from './directives/permission'

// Import Tailwind CSS
import './assets/css/main.css'

// Import global components
import Toast from './components/ui/Toast.vue'
import {
  BaseButton,
  BaseCard,
  BaseInput,
  BaseSelect,
  BaseModal,
  BaseBadge,
  BaseIcon
} from './components/base'

// Créez l'instance Pinia avec plugins
const pinia = createPinia()
pinia.use(resetPlugin)
pinia.use(persistStatePlugin)

// URL d'API par environnement : .env (dev) / .env.production (build prod).
// Le fallback couvre un build sans variable — il pointe sur la prod.
ApiService.init(process.env.VUE_APP_API_URL || 'https://jaaba-cloud.digita.sn/api')

// Créez l'application et ajoutez les plugins
const app = createApp(App)

app.use(router)
app.use(pinia)

// Register custom directives
app.directive('permission', permissionDirective)

// Register global components
app.component('BaseToast', Toast)
app.component('BaseButton', BaseButton)
app.component('BaseCard', BaseCard)
app.component('BaseInput', BaseInput)
app.component('BaseSelect', BaseSelect)
app.component('BaseModal', BaseModal)
app.component('BaseBadge', BaseBadge)
app.component('BaseIcon', BaseIcon)

// Initialiser les stores
initializeStores()

// Montez l'application
app.mount('#app')